import React, { useState, useEffect } from 'react';
import SubmenuList from './SubmenuList';
import HowToUse from './HowToUse';
import Howtousenew from './Howtousenew';
import FooterControl from './FooterControls';
import ReactDOM from 'react-dom';
import Features from './Features';
import QRCode from 'react-qr-code';
const Menu = (props) => {
   const [myJson, setMyJson] = useState([]);
   const [menuList, setMenuList] = useState([]);
   const [uiDataList, setuiDataList] = useState({});
   const [featureMenuList, setfeatureMenuList] = useState([]);
   const [openCloseOnOff, setOpenCloseOnOff] = useState(false);
   const [backliteOnOff, setBackliteOnOff] = useState(false);

   const [buttonArray, setbuttonArray] = useState([]);
   const [buttonArrayObjectList, setbuttonArrayObjectList] = useState([]);
   const [widthUpdate, setwidthUpdate] = useState(false);
   const [updatefeatureType, setupdatedfeatureType] = useState('wwan');
   const [productTitle, setProductTitle] = useState([]);
   const [productType, setproductType] = useState([]);
   // setwidthUpdate(window.mob)
   let howtoUseD = false;
   const getData = () => {
      fetch('data.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      )
         .then(function (response) {
            return response.json();
         })
         .then(function (mydata) {
            return mydata;

         }).then(function (setmydata) {
            setMyJson(setmydata);
            document.title = setmydata.ProjectTitle;
            window.ProjectTitle = setmydata.ProjectTitle;
            window.langugageTranslationFlag = setmydata.LangugageTranslation;//translation fix

            // window.productId = setmydata.productId;
            window.selectedConfig.name = setmydata.productId;
            window.selectedConfig.currentFeatureTypewwan_wlan = `menu_id_${setmydata['currentFeatureTypewwan_wlan']}`
            window.selectedConfig.currentFeatureTypeFingerprint = `menu_id_${setmydata['currentFeatureTypeFingerprint']}`
            window.selectedConfig.currentFeatureTypeSmartCardReader = `menu_id_${setmydata['currentFeatureTypeSmartCardReader']}`
            window.selectedConfig.currentProductClick = `menu_id_${setmydata['currentProductClick']}`
            window.preActiveFeatureSubMenuIdOne = `menu_id_${setmydata['currentFeatureTypewwan_wlan']}`
            window.preActiveFeatureSubMenuIdTwo = `menu_id_${setmydata['currentFeatureTypeFingerprint']}`
            window.preActiveFeatureSubMenuIdThree = `menu_id_${setmydata['currentFeatureTypeSmartCardReader']}`
            window.preActiveCurrentProductClick = `menu_id_${setmydata['currentProductClick']}`
            window.currentAccordianActiveMenuID = `accordion_${setmydata['currentAccordianActiveMenu']}`;
            // console.log();
            let feature_list;
            let menuData;
            let productTypeData;
            let uiData;
            let bodyTag = document.getElementsByTagName("BODY")[0]; //translation fix
            if (setmydata.menus[window.LangName] == undefined || !setmydata.LangugageTranslation) { //translation fix
               uiData = setmydata.menus.EN[0];
               bodyTag.classList.add('en'); //translation fix
            } else {
               uiData = setmydata.menus[window.LangName][0];
               bodyTag.classList.add(window.LangName.toLowerCase()); //translation fix
            }
            window.dataUI = uiData;
            if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {
               menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
               feature_list = setmydata.menus[window.LangName].filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
               productTypeData = setmydata.menus[window.LangName].filter(val => val.menuVisibility !== 'hide' && val.id === "ProductType");
            }
            else {
               menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')
               // var mobProducts = menuData[0].items;
               feature_list = setmydata.menus.EN.filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
               productTypeData = setmydata.menus.EN.filter(val => val.menuVisibility !== 'hide' && val.id === "ProductType");

            }
            setMenuList(menuData);
            setuiDataList(uiData);
            setfeatureMenuList(feature_list)
            setproductType(productTypeData);
            langTranslationAlignment(menuData);
            if (setmydata["accordianClick"]) {
               const setAllItems = () => {
                  const allItemsObj = menuData.flatMap((obj) => [
                     obj.id,
                     ...obj.items.map((item) => item.id),
                  ]);
                  setbuttonArray(allItemsObj);
               };
               setAllItems();
               const setAllAccordion = () => {
                  const allAccordionObj = menuData.flatMap((obj) => [
                     obj,
                     ...obj.items.map((item) => item),
                  ]);
                  setbuttonArrayObjectList(allAccordionObj);
               };
               setAllAccordion();

            } else {
               menuData.map((menu) => {
                  menu.items.map(item => {
                     if (item.id !== undefined) {
                        setbuttonArray((buttonArray) => [...buttonArray, item.id]);
                        setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);
                     }
                  })
               })
            }
         });
   }

   // Changes for QR code update
   if (window.location.href) {
      let url = window.location.href.split('?')[0];
      if (!url.endsWith('index.html')) {
         if (!url.endsWith('/')) url += '/';
         url += 'index.html';
      }
      let params = window.location.href.split('?')[1];
      let newParames = '?qr=1';
      if (params != undefined && !params.includes('qr=')) {
         newParames = newParames + '&' + params;
      } else if (params != undefined && params.includes('qr=')) {
         newParames = '?' + params;
      }

      url = url + newParames;

      /*Code for Content qr */
      if (params != undefined && params.includes('contentURL=')) {
         let contentURL = params.split('contentURL=')[1];
         url = contentURL + '?qr=1';
      }
      /*Code for Content qr End*/




      /*Code for Content qr end */

      // if(window.ContentURLforQR != )

      window.linkForGenerateQR = `${url}`;
   }

   const langTranslationAlignment = (menuData) => {
      // console.log('window.langugageTranslationFlag ', window.langugageTranslationFlag)
      if (!window.dataUI) return;

      const { ui } = window.dataUI;
      document.title = ui.projectTitle;
      
      const elements = {
         moveText: document.getElementById('move_text'),
         rotateText: document.getElementById('rotate_text'),
         zoomText: document.getElementById('zoom_text'),
         exploreButton: document.getElementById('exploreButtton'),
         previousView: document.getElementById("previousView"),
         resetView: document.getElementById("resetView"),
         nextView: document.getElementById("nextView"),
         mobHowToUseText: document.getElementById("mobHowToUseText"),
         moveHowToUse: document.getElementById("move_how_to_use"),
         rotateHowToUse: document.getElementById("rotate_how_to_use"),
         zoomHowToUse: document.getElementById("zoom_how_to_use"),
         accordionContainer: document.getElementById("accordionContainer"),
         tooltipText: document.querySelector(".tooltiptext"),
         webXRTEXT: document.querySelector(".portraitButtonText"),
         selectProductMob: document.getElementById("select_type1"),
         mobTypeMenu: document.querySelector(".portraitButtonProducttypeMenu"),
         howPopMoveText: document.querySelector("#move span"),
         howPopRotateText: document.querySelector("#rotate span"),
         howPopZoomText: document.querySelector("#zoom span"),
         howPopMoveImg: document.querySelector("#move img"),
         howPopRotateImg: document.querySelector("#rotate img"),
         howPopZoomImg: document.querySelector("#zoom img")
      };

      // Set text content
      elements.moveText.innerHTML = ui.move;
      elements.rotateText.innerHTML = ui.rotate;
      elements.zoomText.innerHTML = ui.zoom;
      elements.exploreButton.innerHTML = ui.exploreProductIn3D;

      return; //translation fix
      // function to set fontSize
      const setCommonFontSizeFooter = (size) => {
         elements.previousView.style.fontSize = `${size}px`;
         elements.resetView.style.fontSize = `${size}px`;
         elements.nextView.style.fontSize = `${size}px`;
      };
      const setCommonFontSizeLoaderText = (size) => {
         elements.moveText.style.fontSize = `${size}px`;
         elements.rotateText.style.fontSize = `${size}px`;
         elements.zoomText.style.fontSize = `${size}px`;
      };
      const setCommonFontSizeAccordian = (size) => {
         var radioButtons = document.querySelectorAll(".accordionContent .subMenu .subMenuBtn");
         radioButtons.forEach((item) => {
            item.style.fontSize = `${size}px`
         })
         var radioButtons = document.querySelectorAll(".accordionContainer .menu .text");
         radioButtons.forEach((item) => {
            item.style.fontSize = `${size}px`
         })
      };
      const alignHowtoPopText = (left) => {
         elements.howPopMoveText.style.left = `${left}px`;
         elements.howPopRotateText.style.left = `${left}px`;
         elements.howPopZoomText.style.left = `${left}px`;
      };
      const alignHowtoPopImg = (marginLeft) => {
         elements.howPopMoveImg.style.marginLeft = `${marginLeft}px`;
         elements.howPopRotateImg.style.marginLeft = `${marginLeft}px`;
         elements.howPopZoomImg.style.marginLeft = `${marginLeft}px`;
      };
      const langCode = ui.langcode.toLowerCase();
      switch (langCode) {
         case "da":
            if (window.mob && window.innerHeight > window.innerWidth) {

            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "de":
            if (window.mob && window.innerHeight > window.innerWidth) {

            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {
               alignHowtoPopText(-26)
               alignHowtoPopImg(158)
            }
            break;
         case "es":
            if (window.mob && window.innerHeight > window.innerWidth) {
               if (window.isipad && window.innerHeight > window.innerWidth){
                  elements.selectProductMob.style.marginTop = '15px';
               }else{
                  elements.selectProductMob.style.marginTop = '4px';
               }
            } else if (window.isipad && window.innerHeight > window.innerWidth) {
            } else {

            }
            break;
         case "fr":
            if (window.mob && window.innerHeight > window.innerWidth) {
               setCommonFontSizeLoaderText(37)
               setTimeout(() => {
                   if (window.isipad && window.innerHeight > window.innerWidth){
                     elements.selectProductMob.style.marginTop = '15px';
                  }else{
                     elements.selectProductMob.style.marginTop = '4px';
                  }
                  elements.mobTypeMenu.style.marginTop = '13px';
                  elements.mobTypeMenu.style.paddingRight = '14px';
                  elements.mobTypeMenu.style.width = '100%';

               }, 1000);
            } else if (window.isipad && window.innerHeight > window.innerWidth) {
               setCommonFontSizeLoaderText(37)
            } else {
               setCommonFontSizeLoaderText(39);
               setTimeout(() => {
                  setCommonFontSizeAccordian(14)
               }, 1000);
            }
            break;
         case "fr-ca":
            if (window.mob && window.innerHeight > window.innerWidth) {
               setCommonFontSizeLoaderText(37)
               setTimeout(() => {
                  elements.selectProductMob.style.marginTop = '4px';
                  elements.mobTypeMenu.style.marginTop = '13px';
                  elements.mobTypeMenu.style.paddingRight = '20px';
                  elements.mobTypeMenu.style.width = '100%';
                  elements.webXRTEXT.style.width = '85%';
               }, 1000);
            } else if (window.isipad && window.innerHeight > window.innerWidth) {
               setCommonFontSizeLoaderText(37)
            } else {
               setCommonFontSizeLoaderText(39);
               setTimeout(() => {
                  setCommonFontSizeAccordian(14)
               }, 1000);
            }
            break;
         case "it":
            if (window.mob && window.innerHeight > window.innerWidth) {
               elements.selectProductMob.style.marginTop = '4px';
            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {
               setTimeout(() => {
                  setCommonFontSizeAccordian(14)
               }, 1000);
            }
            break;
         case "ja":
            if (window.mob && window.innerHeight > window.innerWidth) {

            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "ko":
            if (window.mob && window.innerHeight > window.innerWidth) {

            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "nl":
            if (window.mob && window.innerHeight > window.innerWidth) {

            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {
               alignHowtoPopText(-26)
               alignHowtoPopImg(158)
            }
            break;
         case "no":
            if (window.mob && window.innerHeight > window.innerWidth) {
               setTimeout(() => {
                  elements.mobTypeMenu.style.marginTop = '13px';
                  elements.mobTypeMenu.style.paddingRight = '20px';
                  elements.mobTypeMenu.style.width = '100%';
                  elements.webXRTEXT.style.width = '85%';
               }, 1000);

            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "pl":
            if (window.mob && window.innerHeight > window.innerWidth) {
               elements.selectProductMob.style.marginTop = '4px';
            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {
               alignHowtoPopText(-26)
               alignHowtoPopImg(158)
            }
            break;
         case "pt-br":
            if (window.mob && window.innerHeight > window.innerWidth) {
               elements.selectProductMob.style.marginTop = '4px';
            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "sv":
            if (window.mob && window.innerHeight > window.innerWidth) {
               setTimeout(() => {
                  elements.mobTypeMenu.style.marginTop = '13px';
                  elements.mobTypeMenu.style.paddingRight = '20px';
                  elements.mobTypeMenu.style.width = '100%';
                  elements.webXRTEXT.style.width = '85%';
               }, 1000);
            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "zh-cn":
            if (window.mob && window.innerHeight > window.innerWidth) {
               setTimeout(() => {
                  elements.mobTypeMenu.style.marginTop = '13px';
                  elements.mobTypeMenu.style.paddingRight = '20px';
                  elements.mobTypeMenu.style.width = '100%';
                  elements.webXRTEXT.style.width = '85%';
               }, 1000);
            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "zh-tw":
            if (window.mob && window.innerHeight > window.innerWidth) {
               setTimeout(() => {
                  elements.mobTypeMenu.style.marginTop = '13px';
                  elements.mobTypeMenu.style.paddingRight = '20px';
                  elements.mobTypeMenu.style.width = '100%';
                  elements.webXRTEXT.style.width = '85%';
               }, 1000);
            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         case "zh-hk":
            if (window.mob && window.innerHeight > window.innerWidth) {
               setTimeout(() => {
                  elements.mobTypeMenu.style.marginTop = '13px';
                  elements.mobTypeMenu.style.paddingRight = '20px';
                  elements.mobTypeMenu.style.width = '100%';
                  elements.webXRTEXT.style.width = '85%';
               }, 1000);
            } else if (window.isipad && window.innerHeight > window.innerWidth) {

            } else {

            }
            break;
         default:
            break;
      }

   }
   useEffect(() => {
      const menuref = document.querySelector('.menuContainer');
      window.mainMenuRef = menuref;
   })

   useEffect(() => {
      setTimeout(() => {
         getData();
      }, 1000);

   }, [])

   window.checkWindowSize = function () {
      setwidthUpdate(window.mob)
   }

   const menuExpandCollaps = () => {
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      } else {
         mainMenu.classList.add('collapsed');
         mainMenu.classList.remove('expanded');
         var getExpandedAccordion = document.querySelectorAll('.menu.active');
         if (getExpandedAccordion.length !== 0) {
            for (var i = 0; i <= getExpandedAccordion.length; i++) {
               if (getExpandedAccordion[i] !== undefined) {
                  getExpandedAccordion[i].classList.remove('active');
                  getExpandedAccordion[i].nextSibling.style.height = '0px';
               }
            }
         }
      }

   }
   const howToUSEClick = (e) => {

      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      document.querySelector('#howToUSEText').focus();
      if (howtoUseD) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });

         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      } else {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '1');
         });
         document.getElementById('howToUSE').style.opacity = "1";
         if (window.isipad && window.innerWidth > window.innerHeight) {
            document.getElementById('howToUSE').style.marginTop = "2.7%";

         } else {
            document.getElementById('howToUSE').style.marginTop = "-1%";

         }
         document.getElementById('howToUSE').style.animationName = "example1";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#FFFFFF";
         document.getElementById('howToUseMenu').firstChild.classList.add('active');

         howtoUseD = true;
      }
   }
   const closeHandle = (event) => {
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }

   };

   const closeHandleMenu = (event) => {
      //TabIndex Click Functionality
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });

         document.querySelector('#howToUseMenu').focus();
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }
   };

   const accordionMenu = (e) => {
      //For setting Accordion aria-expanded collpase
      let currentTargetAccordion1 = e.target.closest(".menu");
      currentTargetAccordion1.setAttribute("aria-expanded", "false");
      //For setting SubMenuButton TabIndex -1 and aria-hidden true
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn[tabIndex='1']");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];
      subMenuTabIndex1Arr.forEach((ele) => {
         ele.setAttribute("tabIndex", "-1");
         let parentElement = ele.parentElement;
         if (parentElement) {
            parentElement.setAttribute("aria-hidden", "true");
         }
      });

      // For Radio: input should be TabIndex -1
      let subMenuRadioTabIndex1 = document.querySelectorAll(
         ".radioFocus[tabIndex='1']"
      );
      let subMenuRadioTabIndex1Arr = [...subMenuRadioTabIndex1];
      subMenuRadioTabIndex1Arr.forEach((ele) => {
         ele.setAttribute("tabIndex", "-1");
      });


      let subMenu = document.querySelectorAll(".subMenuBtn.list")
      subMenu.forEach((item) => {
         item.classList.remove('active');
      })
      window.hidePopUp();
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;

      myJson.menus.EN.map((menu_Item) => {
         if ("accordion_" + menu_Item['id'] === e.target.closest('.menu').id) {
            return window.execute_all(menu_Item);

         }
      })

      setTimeout(function () {
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
      }, 500)

      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      }

      if (e.target.closest('.menu').classList.contains('active')) {
         if ((!window.mob && window.innerWidth > window.innerHeight)) {
            e.target.closest('.menu').classList.remove('active');
            e.target.closest('.menu').nextSibling.style.height = '0px';
         }
      }
      else {
         var menu_active = document.querySelectorAll('.menu');
         for (var i = 0; i <= menu_active.length - 1; i++) {
            if (menu_active[i].id !== 'howToUseMenu') {
               menu_active[i].classList.remove('active')
               menu_active[i].nextSibling.style.height = '0px';
            }
         }

         e.target.closest('.menu').classList.add('active');
         window.selectedButtonType = e.target.closest('.menu').id;
         var accordionContent = e.target.closest('.menu').nextSibling.firstChild;
         if (accordionContent != null) {
            e.target.closest('.menu').nextSibling.style.height = accordionContent.offsetHeight + 'px';
         }

         //TabIndex Click Functionality
         //make tabIndex 1
         let currentTargetAccordion = e.target.closest(".menu.active");
         let currentTargetAccordionSubMenu = currentTargetAccordion.nextSibling;
         let subMenuElement =
            currentTargetAccordionSubMenu.querySelectorAll(".subMenuBtn");
         let subMenuElementArr = [...subMenuElement];

         currentTargetAccordion.setAttribute("aria-expanded", "true");

         subMenuElementArr.forEach((ele) => {
            // Check if the element has the class 'radioButton'
            if (ele.classList.contains("radioButton")) {
               ele.setAttribute("tabIndex", "-1");
               ele.childNodes[0].setAttribute("tabIndex", "1");
            } else {
               ele.setAttribute("tabIndex", "1");
            }
            let parentElement = ele.parentElement;
            if (parentElement) {
               parentElement.setAttribute("aria-hidden", "false");
            }
         });

      }

      if (orentation === 90) {
         closeHandle();
      }

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
      }
      window.updateSlider()
   }
   const subMenu = (e) => {

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         selectedSubMenu[i].classList.remove('active')
      }
      e.target.classList.add('active');
   }
   var data1 = {
      method: accordionMenu,
      method2: howToUSEClick,
      method3: subMenu,
   }
   const handleTransitions = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.animationStatus = 'on';

      } else {
         window.animationStatus = 'off';

      }

   }
   const handleTransitionskeyPress = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.animationStatus = 'off';
         document.getElementById("animSwitchValue").checked = false;
      } else {
         window.animationStatus = 'on';
         document.getElementById("animSwitchValue").checked = true;

      }

   }
   var animStopped = true;

   const conScreenControlHandler = (e) => {
      const isChecked = document.getElementById("onScreenControlsValue").checked;
      // add this code for prevent errors
      if (document.getElementById("footerControlDesk")) {
         document.getElementById("footerControlDesk").setAttribute("aria-hidden", "false");
      }

      if (isChecked === true) {
         const rotateLeftBtnFocus = document.getElementById("rLeft");
         setTimeout(() => {
            rotateLeftBtnFocus.focus()
         }, 500)
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';
         if (window.mob && !window.isipad) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            if (window.innerWidth > window.innerHeight) {
               document.getElementById('footerControls').style.display = 'block';
               document.getElementById('footerControls').style.bottom = "55px";
            } else {
               document.getElementById('footerControls').style.display = 'none';
            }
         } else {
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "2");
               navBtn[i].setAttribute("aria-hidden", "false");
            }
            document.getElementById('footerControls').style.bottom = "55px";
         }
      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
               navBtn[i].setAttribute("aria-hidden", "true");
            }
            setTimeout(function () {
               animStopped = true;
            }, 200);
         }

      }

   }

   const conScreenControlHandlerkeyPress = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      // add this code for prevent errors
      if (document.getElementById("footerControlDesk")) {
         document.getElementById("footerControlDesk").setAttribute("aria-hidden", "false");
      }
      if (isChecked === false) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         }
         else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            document.getElementById('footerControls').style.bottom = "55px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "1");
            }
            document.getElementById("onScreenControlsValue").checked = true;
         }


      } else {
         window.animation1SwitchGlobal = 'off';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            document.getElementById("onScreenControlsValue").checked = false;
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {

               animStopped = true;
            }, 200);
         }

      }

   }

   // menu visiblity
   const handleSideMenuListVisibility = (menu_id, menu_type) => {
      // console.log(menu_id)
      setTimeout(() => {
         if (document.getElementById(`menu_id_${menu_id}`).childNodes[0]) {
            document.getElementById(`menu_id_${menu_id}`).childNodes[0].focus();
            document.getElementById(`menu_id_${menu_id}`).childNodes[0].checked = true;
         }
         if (document.getElementById(window.preActiveFeatureSubMenuIdOne)) {
            document.getElementById(window.preActiveFeatureSubMenuIdOne).childNodes[0].checked = true;
         }
         if (document.getElementById(window.preActiveFeatureSubMenuIdTwo)) {
            document.getElementById(window.preActiveFeatureSubMenuIdTwo).childNodes[0].checked = true;
         }
         if (document.getElementById(window.preActiveFeatureSubMenuIdThree)) {
            document.getElementById(window.preActiveFeatureSubMenuIdThree).childNodes[0].checked = true;
         }
      }, 0)

      setTimeout(() => {
         const container = document.querySelector(".accordionContainer").childNodes;
         const filteredItems = [...container].filter(item => item.classList.contains('menu'));

         filteredItems.forEach(item => {
            item.setAttribute('tabindex', '1');
         });

         let currentTargetAccordion = document.getElementById(`menu_id_${menu_id}`);
         let currentTargetAccordionSubMenu = currentTargetAccordion.parentElement;
         let subMenuElement = currentTargetAccordionSubMenu.querySelectorAll('.subMenuBtn');

         let subMenuElementArr = [...subMenuElement];
         subMenuElementArr.forEach(ele => {
            if (ele.classList.contains('radioButton')) {
               ele.setAttribute("tabIndex", "-1");
               ele.childNodes[0].setAttribute("tabIndex", "1");
            } else {
               ele.setAttribute("tabIndex", "1");
            }
            let parentElement = ele.parentElement;
            if (parentElement) {
               parentElement.setAttribute("aria-hidden", "false");
            }
         });
      }, 0)

      if (menu_id == "laptop2in1") {
         // debugger
         let isPositionViewExist = menuList.find(item => item.id === "positionView")
         console.log("isPositionViewExist", isPositionViewExist);
         let finalUpdatedMenuList;
         if (isPositionViewExist === undefined) {
            let totalMenu = myJson.menus[window.LangName];
            const changeMenuItems = totalMenu.find(item => item.id === "positionView");
            console.log("changeMenuItems", changeMenuItems);
            const updatedMenuItems = { ...changeMenuItems, menuVisibility: "show" }
            console.log("updatedMenuItems", updatedMenuItems);
            // console.log(updatedMenuItems)
            // const removedMenuItemList = menuList.filter(item => item.id !== "positionView");

            let removeConfigurationId = ["smartCardReader", "noSmartCardReader"];
            const changedMenu3 = myJson.menus[window.LangName].find(item => item.id === "configuration");
            const changeMenuItems3 = myJson.menus[window.LangName].find(item => item.id === "configuration").items;
            const updatedMenuItems3 = changeMenuItems3.map(item => removeConfigurationId.includes(item.id) ? { ...item, subMenuVisibility: false } : item);
            const updatedMenu3 = { ...changedMenu3, items: updatedMenuItems3 };
            const removedMenuItemList = menuList.filter(item => item.id !== "configuration" || item.id !== "positionView");
            console.log("removedMenuItemList", removedMenuItemList);
            // finalUpdatedMenuList = [removedMenuItemList[0],updatedMenuItems,removedMenuItemList[1],removedMenuItemList[2],updatedMenu3];
            finalUpdatedMenuList = [removedMenuItemList[0], updatedMenuItems, removedMenuItemList[1], updatedMenu3];
            langTranslationAlignment(finalUpdatedMenuList);
            setMenuList(finalUpdatedMenuList);
            // console.log(finalUpdatedMenuList)
            let tempBtnArray = [];

            let tempbuttonArrayObjectList = [];
            finalUpdatedMenuList.map((menu) => {
               menu.items.map(item => {
                  if (item.id !== undefined) {
                     tempBtnArray = [...tempBtnArray, item.id];
                  }
                  tempbuttonArrayObjectList = [...tempbuttonArrayObjectList, item]
               })
            })
            setbuttonArray(tempBtnArray);
            setbuttonArrayObjectList(tempbuttonArrayObjectList);

         } else {
            let removeConfigurationId = ["smartCardReader", "noSmartCardReader"];
            const changedMenu3 = myJson.menus[window.LangName].find(item => item.id === "configuration");
            const changeMenuItems3 = myJson.menus[window.LangName].find(item => item.id === "configuration").items;
            const updatedMenuItems3 = changeMenuItems3.map(item => removeConfigurationId.includes(item.id) ? { ...item, subMenuVisibility: false } : item);
            const updatedMenu3 = { ...changedMenu3, items: updatedMenuItems3 };

            const removedMenuItemList = menuList.filter(item => item.id !== "configuration" || item.id !== "positionView");
            console.log(removedMenuItemList)
            const finalUpdatedMenuList = [...removedMenuItemList.slice(0, 3), updatedMenu3];
            setMenuList(finalUpdatedMenuList);
            console.log(finalUpdatedMenuList);
            setTimeout(() => {

               langTranslationAlignment(finalUpdatedMenuList);
            }, 1000);
            let tempBtnArray = [];

            let tempbuttonArrayObjectList = [];
            finalUpdatedMenuList.map((menu) => {
               menu.items.map(item => {
                  if (item.id !== undefined) {
                     tempBtnArray = [...tempBtnArray, item.id];
                  }
                  tempbuttonArrayObjectList = [...tempbuttonArrayObjectList, item]
               })
            })
            setbuttonArray(tempBtnArray);
            setbuttonArrayObjectList(tempbuttonArrayObjectList);
         }

      }
      else if (menu_id === "laptop") {
         let totalMenu = myJson.menus[window.LangName];
         const changeMenuItems = totalMenu.find(item => item.id === "positionView");
         const updatedMenuItems = { ...changeMenuItems, menuVisibility: "hide" }

         const removedPositionView = totalMenu.filter(item => item.id !== "positionView");

         let removedConfigurationListID = ["smartCardReader", "noSmartCardReader"];
         const changedMenu3 = removedPositionView.find(item => item.id === "configuration");
         const changeMenuItems3 = removedPositionView.find(item => item.id === "configuration").items;
         const updatedMenuItems3 = changeMenuItems3.map(item => removedConfigurationListID.includes(item.id) ? { ...item, subMenuVisibility: false } : item);
         const updatedMenu3 = { ...changedMenu3, items: updatedMenuItems3 };

         let removedConfigurationList = removedPositionView.filter(item => item.id !== "configuration");

         // let updatedMenuLIst = [removedConfigurationList[1],removedConfigurationList[2],removedConfigurationList[3],updatedMenu3]
         let updatedMenuLIst = [removedConfigurationList[1], removedConfigurationList[2], updatedMenu3]
         console.log(updatedMenuLIst)
         setMenuList(updatedMenuLIst);
         langTranslationAlignment(updatedMenuLIst);
         let tempBtnArray = [];

         let tempbuttonArrayObjectList = [];
         updatedMenuLIst.map((menu) => {
            menu.items.map(item => {
               if (item.id !== undefined) {
                  tempBtnArray = [...tempBtnArray, item.id];
               }
               tempbuttonArrayObjectList = [...tempbuttonArrayObjectList, item]
            })
         })
         setbuttonArray(tempBtnArray);
         setbuttonArrayObjectList(tempbuttonArrayObjectList);


      }
   }

   const handleMenuClick = (menu_object, e) => {

      let cameraId = menu_object['id'];
      let cameraName = menu_object['cameraName'];
      let cameraType = menu_object['type'];
      let productType = cameraType;
      let productTypecheck = menu_object['type'];
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      // if (menu_object.sequenceName) window.scene.applySequence(window[menu_object.sequenceName])
      window.hidePopUp();
      window.currID = menu_object['id'];

      if (productType == "configuration" && menu_object['featureType'] != "fingerprint") {
         window.featureType = menu_object['featureType'];
         if ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) {
            setupdatedfeatureType(window.featureType);
         }
      }

      if (productTypecheck == "ProductType") {
         window.productName = menu_object['id'];
         window.itCameraType = menu_object['id'];
         if ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) {
            // setupdatedProductId(window.productName);
         }
         // code for menu hide/show
         handleSideMenuListVisibility(cameraId, cameraType)
      }

      window.execute_all(menu_object);
      setMenuActive(cameraId, cameraType, e);
      if (orentation === 90) {
         closeHandle();
      }
   }

   var updateAriaLabelSelected = (menuid) => {
      const subMenuItem = document.getElementById(`menu_id_${menuid}`);
      const menuId = `menu_id_${menuid}`;
      const menuName = subMenuItem.innerText;
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];

      subMenuTabIndex1Arr.forEach(ele => {
         let getId = ele.getAttribute("id");

         if (getId === menuId) {
            // ele.setAttribute("aria-label", `${menuName} selected`);
            ele.setAttribute("aria-current", "true");
         } else {
            // ele.setAttribute("aria-label", "");
            ele.setAttribute("aria-current", "false");
         }
      });
   }


   const setMenuActive = (menu_id, menu_type, e) => {
      if (menu_type === 'configuration' && (menu_id === "fpr" || menu_id === "noFpr")) {
         const prefprActive = document.querySelector('.radioButton.fprActive');
         if (prefprActive) {
            prefprActive.classList.remove('fprActive')
            prefprActive.querySelector('input').checked = false;
         }

         const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
         window.selectedConfig.currentFeatureTypeFingerprint = featureModeBtn.id;
         if (featureModeBtn) {
            featureModeBtn.classList.add('fprActive')
            featureModeBtn.querySelector('input').checked = true;
         }
         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
            setTimeout(() => {
               const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
               window.selectedConfig.currentFeatureTypeFingerprint = featureModeBtn.id;
               console.log(featureModeBtn)
               if (featureModeBtn) {
                  featureModeBtn.classList.add('fprActive')
                  featureModeBtn.querySelector('input').checked = true;
               }
               var previousFeatureACtive = document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan)
               if (previousFeatureACtive) {
                  previousFeatureACtive.classList.add('featureModeActive')
               }
               var previousCardACtive = document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader)
               if (previousCardACtive) {
                  previousCardACtive.classList.add('cardActive')
               }
            }, 0);

         }
      } else if (menu_type === 'configuration' && (menu_id === "smartCardReader" || menu_id === "noSmartCardReader")) {
         const preCardActive = document.querySelector('.radioButton.cardActive');
         if (preCardActive) {
            preCardActive.classList.remove('cardActive')
            preCardActive.querySelector('input').checked = false;
         }

         const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
         window.selectedConfig.currentFeatureTypeSmartCardReader = featureModeBtn.id;

         const prefeatureModeActive = document.querySelector('.radioButton.featureModeActive');
         if (prefeatureModeActive) {
            prefeatureModeActive.classList.remove('featureModeActive')
            prefeatureModeActive.querySelector('input').checked = false;
         }
         if (document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader) != undefined) {
            if (window.selectedConfig.currentFeatureTypeSmartCardReader == 'menu_id_smartCardReader') {
               window.selectedConfig.currentFeatureTypewwan_wlan = 'menu_id_wwanBack';
               document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).classList.add('featureModeActive')
               document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).querySelector('input').checked = true;
            }
            else if (window.selectedConfig.currentFeatureTypeSmartCardReader == 'menu_id_noSmartCardReader') {
               window.selectedConfig.currentFeatureTypewwan_wlan = 'menu_id_wlanBack';
               document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).classList.add('featureModeActive')
               document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).querySelector('input').checked = true;
            }
         }

         if (featureModeBtn) {
            featureModeBtn.classList.add('cardActive')
            featureModeBtn.querySelector('input').checked = true;
         }

         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
            setTimeout(() => {
               const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
               window.selectedConfig.currentFeatureTypeSmartCardReader = featureModeBtn.id;
               if (featureModeBtn) {
                  featureModeBtn.classList.add('cardActive')
                  featureModeBtn.querySelector('input').checked = true;
               }

               var previousFeatureACtive = document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan)
               if (previousFeatureACtive) {
                  previousFeatureACtive.classList.add('featureModeActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }
               var previousfprActive = document.getElementById(window.selectedConfig.currentFeatureTypeFingerprint)
               if (previousfprActive) {
                  previousfprActive.classList.add('fprActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }

            }, 0);

         }

      }
      else if (menu_type === 'configuration') {
         const prefeatureModeActive = document.querySelector('.radioButton.featureModeActive');
         if (prefeatureModeActive) {
            prefeatureModeActive.classList.remove('featureModeActive')

            prefeatureModeActive.querySelector('input').checked = false;
         }

         const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);

         window.selectedConfig.currentFeatureTypewwan_wlan = featureModeBtn.id;
         const preCardActive = document.querySelector('.radioButton.cardActive');
         if (preCardActive) {
            preCardActive.classList.remove('cardActive')
            preCardActive.querySelector('input').checked = false;
         }
         if (document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader) != undefined) {
            if (window.selectedConfig.currentFeatureTypewwan_wlan == 'menu_id_wwanBack') {
               window.selectedConfig.currentFeatureTypeSmartCardReader = 'menu_id_smartCardReader';
               document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).classList.add('cardActive')
               document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).querySelector('input').checked = true;
            }
            else if (window.selectedConfig.currentFeatureTypewwan_wlan == 'menu_id_wlanBack') {
               window.selectedConfig.currentFeatureTypeSmartCardReader = 'menu_id_noSmartCardReader';
               document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).classList.add('cardActive')
               document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).querySelector('input').checked = true;
            }
         }

         if (featureModeBtn) {
            featureModeBtn.classList.add('featureModeActive')
            featureModeBtn.querySelector('input').checked = true;
         }

         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {

            setTimeout(() => {
               const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
               window.selectedConfig.currentFeatureTypewwan_wlan = featureModeBtn.id;
               if (featureModeBtn) {
                  featureModeBtn.classList.add('featureModeActive')
                  featureModeBtn.querySelector('input').checked = true;

               }
               var previousCardACtive = document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader)
               if (previousCardACtive) {
                  previousCardACtive.classList.add('cardActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }

               var previousfprActive = document.getElementById(window.selectedConfig.currentFeatureTypeFingerprint)
               if (previousfprActive) {
                  previousfprActive.classList.add('fprActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }

            }, 0);
         }

      } else if (menu_type === 'ProductType') {
         const preProductActive = document.querySelector('.radioButton.productModeactive');
         if (preProductActive) {
            preProductActive.classList.remove('productModeactive')
            preProductActive.querySelector('input').checked = false;
         }

         const productModeBtn = document.getElementById(`menu_id_${menu_id}`);
         window.selectedConfig.currentProductClick = productModeBtn.id;
         if (productModeBtn) {
            productModeBtn.classList.add('productModeactive')
            productModeBtn.querySelector('input').checked = true;
         }

         setTimeout(() => {
            const selectActiveProduct = document.getElementById(`menu_id_${menu_id}`);
            window.selectedConfig.currentProductClick = selectActiveProduct.id;
            if (selectActiveProduct) {
               selectActiveProduct.classList.add('productModeactive')
               // selectActiveProduct.querySelector('input').checked = true;

            }
            window.selectedConfig.currentFeatureClick = window.preActiveFeatureSubMenuIdOne;
            window.selectedConfig.currentFeatureFPRClick = window.preActiveFeatureSubMenuIdTwo;
            window.selectedConfig.currentFeatureCardClick = window.preActiveFeatureSubMenuIdThree;
            window.selectedConfig.currentFeatureTypeFingerprint = window.preActiveFeatureSubMenuIdTwo;
            window.selectedConfig.currentFeatureTypewwan_wlan = window.preActiveFeatureSubMenuIdOne;
            
            if (document.getElementById(window.preActiveFeatureSubMenuIdOne)) {
               document.getElementById(window.preActiveFeatureSubMenuIdOne).classList.add('featureModeActive')
            }

            if (document.getElementById(window.preActiveFeatureSubMenuIdTwo)) {
               document.getElementById(window.preActiveFeatureSubMenuIdTwo).classList.add('fprActive')
            }

            if (document.getElementById(window.preActiveFeatureSubMenuIdThree)) {
               document.getElementById(window.preActiveFeatureSubMenuIdThree).classList.add('cardActive')
            }

            if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {


            }
         }, 0);
               //To keep menu active when we switch from laptop to 2in1
      if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
         if (window.selectedConfig.currentProductClick == 'menu_id_laptop') {
            setTimeout(() => {
            if (document.getElementById('accordion_productView')) {
               document.getElementById('accordion_configuration').classList.remove('active');
               document.getElementById('accordion_productView').classList.add('active');
            }
         }, 1);
         } else if (window.selectedConfig.currentProductClick == 'menu_id_laptop2in1') {
            setTimeout(() => {
               if (document.getElementById('accordion_positionView')) {
                  document.getElementById('accordion_productView').classList.remove('active');
                  document.getElementById('accordion_configuration').classList.remove('active');
                  document.getElementById('accordion_positionView').classList.add('active');
               }
            }, 1);
         }  
      }
      }


      let currentClass;
      let preActive;
      var currentActive;
      if (e != undefined) {
         currentActive = e.target.closest('li.subMenuBtn');
         currentClass = currentActive?.classList[0];
         preActive = document.querySelector('.' + currentClass + '.active');
         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
            if (preActive?.id == currentActive?.id) {
               setTimeout(() => {
                  currentActive?.classList.remove('active')
               }, 100);
            } else {
               currentActive?.classList.add('active');
               preActive?.classList.remove('active')
            }
         } else {
            preActive?.classList.remove('active');
            currentActive?.classList.add('active');
         }
      }
      else {

         if (document.getElementById('menu_id_' + menu_id) != null) {
            currentActive = document.getElementById('menu_id_' + menu_id);
            currentClass = currentActive.classList[0];
            preActive = document.querySelector('.' + currentClass + '.active');

            if (preActive != null) {
               preActive.classList.remove('active');
            }


            if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
               if (preActive?.id == currentActive?.id) {
                  // console.log(currentActive,"currentActive")
                  setTimeout(() => {
                     currentActive.classList.remove('active')
                  }, 100);
               } else {
                  currentActive.classList.add('active')
               }
            } else {

               currentActive.classList.add('active');
            }
         }
      }
      updateAriaLabelSelected(menu_id)
      window.selectedConfig.currentSubMenuClick = currentActive.id;
      window.selectedButton = menu_id;
      window.checkedButton = menu_id;
      window.selectedButtonType = menu_type;
      window.updateSlider();
   }


   //skip next previous port 
   let skipNextPreviousPortArrId = ["laptop2in1", "laptop", "noSmartCardReader", "smartCardReader"];

   const onPreviousMode = () => {

      setTimeout(() => {
         if (document.querySelector('.subHeadingText')) {
            document.querySelector('.subHeadingText').classList.add(window.dataUI.ui.langcode)
         }
      }, 10);

      window.hidePopUp();
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);

      let cameraName;
      window.updateSlider();
      let finalButtonArray = buttonArray.filter(item => !skipNextPreviousPortArrId.includes(item));

      var prevButton;
      var selectedButtonIndex = finalButtonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton == 'onResetMode' || window.checkedButton == '') {
         prevButton = finalButtonArray[finalButtonArray.length - 1];
      } else {

         prevButton = finalButtonArray[selectedButtonIndex - 1];
      }

      if (prevButton == undefined) { prevButton = finalButtonArray[finalButtonArray.length - 1] }

      let result = buttonArrayObjectList.find(object => object.id == prevButton);
      // if (window.selectedButtonType !== result['type']) {
      //    expandMenu(`accordion_${result['type']}`);
      // }

      if (result !== undefined) {
         expandMenu(`accordion_${result['type']}`);
      }

      if (result['id'] === "OpenCloseLid") {
         window.open_close_status = window.open_close_status === "off" ? "on" : "off"
      }

      // if (window.productType != "colors") {
      //    window.storeViewID = result['id']
      // }

      //added condition for backlit keyboard functionality
      if (result['id'] === "BacklitKeyboard") {
         window.backlit_keyboard_status = window.backlit_keyboard_status === "off" ? "on" : "off"
      }

      window.execute_all(result);
      setMenuActive(result['id'], result['type']);


      return false;

   }
   const onNextMode = () => {
      window.hidePopUp();
      setTimeout(() => {
         if (document.querySelector('.subHeadingText')) {
            document.querySelector('.subHeadingText').classList.add(window.dataUI.ui.langcode)
         }
      }, 10);
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      let cameraName;
      window.updateSlider();
      //created this finalButtonArray to skip the color views
      let finalButtonArray = buttonArray.filter(item => !skipNextPreviousPortArrId.includes(item));
      var nextButton;
      var selectedButtonIndex = finalButtonArray.findIndex(element => element === window.checkedButton)
      if (!window.AnimComplated) {
         return
      }
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '') {
         nextButton = finalButtonArray[0];

      } else {
         nextButton = finalButtonArray[selectedButtonIndex + 1];
      }
      if (nextButton === undefined) { nextButton = finalButtonArray[0] }

      let result = buttonArrayObjectList.find(object => object.id === nextButton);

      // if (window.selectedButtonType !== result['type']) {

      //    expandMenu(`accordion_${result['type']}`);
      // }

      if (result !== undefined) {
         expandMenu(`accordion_${result['type']}`);
      }

      if (result['id'] === "OpenCloseLid") {
         window.open_close_status = window.open_close_status === "off" ? "on" : "off"
      }
      if (window.productType != "colors") {
         window.storeViewID = result['id']
      }

      //added condition for backlit keyboard functionality
      if (result['id'] === "BacklitKeyboard") {
         window.backlit_keyboard_status = window.backlit_keyboard_status === "off" ? "on" : "off"
      }

      window.execute_all(result);
      setMenuActive(result['id'], result['type']);

      return false;

   }
   const onReset = () => {
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);

      window.updateSlider();
      if (!window.AnimComplated) {
         return;
      }
      let nextButton;
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '' || window.checkedButton === undefined) {
         window.scene.applySequence(window[window.config.resetSequence]);
      }
      else if (window.checkedButton === 'productView') {
         window.scene.applySequence(window[window.config.resetSequence]);
      }
      else if (window.checkedButton === 'features') {
         nextButton = 'FunctionMode'
      }
      else {
         nextButton = window.checkedButton;
      }
      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.checkedButton !== 'onResetMode' || window.checkedButton !== '') {
         if (result !== undefined) {
            expandMenu(`accordion_${result['type']}`);
         }
      }
      if (result !== undefined) {
         window.execute_all(result);
         setMenuActive(result['id'], result['type']);
      }
   }

   const expandMenu = (menuId) => {
      //TabIndex Click Functionality
      //make tabIndex -1


      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn[tabIndex='1']");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];
      subMenuTabIndex1Arr.forEach(ele => {
         ele.setAttribute("tabIndex", "-1");
         let parentElement = ele.parentElement;
         if (parentElement) {
            parentElement.setAttribute("aria-hidden", "true");
         }
      });


      //TabIndex Click Functionality
      //make tabIndex 1
      let currentTargetAccordion = document.getElementById(`${menuId}`);
      let currentTargetAccordionSubMenu = currentTargetAccordion.nextSibling;
      let subMenuElement = currentTargetAccordionSubMenu.querySelectorAll('.subMenuBtn');
      let subMenuElementArr = [...subMenuElement];
      subMenuElementArr.forEach(ele => {
         ele.setAttribute("tabIndex", "1");
         let parentElement = ele.parentElement;
         if (parentElement) {
            parentElement.setAttribute("aria-hidden", "false");
         }
      });


      if (document.querySelector('.menu.active') != null) {
         document.querySelector('.menu.active').classList.remove('active');
         var accordionContentAll = document.querySelectorAll('.accordionContent');
         for (var i = 0; i <= accordionContentAll.length - 1; i++) {
            accordionContentAll[i].style.height = '0px';
         }
      }
      var accordionContent = document.getElementById(menuId).nextSibling.firstChild;
      if (accordionContent != null) {
         document.getElementById(menuId).classList.add('active')
         document.getElementById(menuId).nextSibling.style.height = accordionContent.offsetHeight + 'px';
      }
   }
   const howToUseMobClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "12";
      document.getElementById('howTousePopup').style.zIndex = "2";
   }
   const [orentation, setOrentation] = useState(window.innerHeight > window.innerWidth ? 0 : 90)


   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';

   const TowerClick = (menuData) => {
      window.execute_all(menuData[0].items[0]);
   }

   //This code is for how to use component resize issue
   const CanvasResizeFunction = () => {
      if (window.innerHeight > window.innerWidth) {
         setOrentation(0)
      } else if (window.innerWidth > window.innerHeight) {
         setOrentation(90)
      } else {
         setOrentation((item) => {
            return item;
         })
      }
   }
   window.addEventListener('resize', CanvasResizeFunction);

   const { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...uiDataList.ui }
   return (
      <>
         <div className='leftMenuWrapper' id='leftMenuWrapper'>
            <div id='mainMenu' className='menuContainer expanded'>
               {myJson.QRSupport && <div className='portraitButton' id={arbuttonName}>
                  <span className='portraitButtonText' id="portraitButtonTextId">{uiDataList.ui?.arMob}</span>
               </div>}
               <div className={`howToUseMob `} id="howToUseMob" onClick={howToUseMobClick} >
                  <span className='portraitButtonText'>{uiDataList.ui?.howToUSE}</span>
               </div>

               <div id="howToUseMenu" tabIndex="-1" aria-label='How to use' role='button' className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClick()
               }}>
                  <div className='icon howtouse'> </div>
                  <div className='text' aria-hidden="true">{howToUSE ?? 'How to use'}</div>
               </div>
               {orentation === 0 ? <Howtousenew data={uiDataList.ui} /> : <HowToUse data={uiDataList.ui} closeHandle={closeHandleMenu} />}
               {
                  ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) ?

                     <div className="accordion_ProductType portraitButton1" id='accordion_ProductType'>
                        <div className='d-flex'>
                           <span className="portraitButtonText" id="select_type1">{productType && productType[0] ? productType[0]?.mobileTitle : 'Product Type'}</span>
                        </div>
                        <ul className='portraitButtonProducttypeMenu'>
                           {
                              productType[0] && productType[0].items.map((item, index) => {
                                 return (
                                    <React.Fragment key={item.id}>
                                       <li className="subMenuBtn radioButton mob" id={`menu_id_${item.id}`} onClick={e => handleMenuClick(item, e)}>
                                          <label>  <input type="radio" value="product1" /></label>
                                          <span className='mobRadioTitle'>  {item.mobileTitle} </span>
                                       </li>
                                    </React.Fragment>
                                 )
                              })

                           }
                        </ul>
                     </div> : null

               }
               <div className='accordionContainer'>
                  {
                     ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) ? menuList.filter(list => list.id != "ProductType").map((list) => {

                        return (
                           <React.Fragment key={list.id}>
                              {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                 <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                    <div className={`icon ${list.id}`} ></div>
                                    <div className='text'>{list.title} {list.title}</div>
                                 </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="-1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                    if (e.key !== 'Enter') {
                                       return
                                    } accordionMenu(e)
                                 }}>
                                    <>
                                       <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                       <div className={`mob_icon mob_icon_${list.id}`}></div>
                                       <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                       <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                    </>
                                 </div>
                              }
                              {list.items && list.items.menuVisibility !== "hide" &&
                                 <SubmenuList
                                    subMenuList={list.items}
                                    orentation={orentation}
                                    handleMenuClick={handleMenuClick}
                                    updatefeatureType={updatefeatureType}
                                 // updateProductId={updateProductId}
                                 />}
                           </React.Fragment>
                        )
                     })
                        :
                        menuList.map((list) => {
                           // console.log(list,'list----')
                           return (
                              <React.Fragment key={list.id}>
                                 {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                    <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                       <div className={`icon ${list.id}`} ></div>
                                       <div className='text'>{list.title} {list.title}</div>
                                    </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} aria-expanded={false} role='button' tabIndex="-1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                       if (e.key !== 'Enter') {
                                          return
                                       } accordionMenu(e)
                                    }}>
                                       <>
                                          <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                          <div className={`mob_icon mob_icon_${list.id}`}></div>
                                          <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                          <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                       </>
                                    </div>
                                 }
                                 {list.items && list.items.menuVisibility !== "hide" && <SubmenuList subMenuList={list.items} orentation={orentation} handleMenuClick={handleMenuClick} />}
                              </React.Fragment>
                           )
                        })

                  }
               </div>
               <div id="menuFooter">
                  {myJson.QRSupport && <div id="qrCode">
                     {/* <img src='images/qrcode.svg' aria-label='qr code image' /> <br /> */}
                     <QRCode
                        size={130}
                        value={window.linkForGenerateQR}
                        style={{ height: "auto" }}
                        className='qrImage'
                        aria-label='qr code image'
                        aria-hidden="true"
                     />
                     <span className='text'> {QR !== undefined ? QR : 'Scan QR code with your mobile device to view the product in your space'}</span>
                  </div>
                  }
                  <div id="animation">
                     <span aria-hidden="true">{ReduceTransitions !== undefined ? ReduceTransitions : 'Reduce Transitions'}</span>
                     <label className="switch" tabIndex="-1" id="animswtich" onKeyPress={handleTransitionskeyPress} >
                        <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={true} aria-label='reduce transitions switch' />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff"></span>
                     </label>
                  </div>
                  {ReactDOM.createPortal(
                     <div id="onScreenControl" className='tooltip'>
                        <span className='' aria-hidden='true'>{onScreenControls ?? 'On-Screen Controls'}
                           <span className="tooltiptext">{hovertext ?? 'Click to toggle controls on/off'}</span>
                        </span>
                        <label className="switch" tabIndex="-1" id="onScreenControls" onKeyPress={conScreenControlHandlerkeyPress}>
                           <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="onScreenControlsValue" type="checkbox" onChange={conScreenControlHandler} aria-label='on-screen controls switch' />
                           <span className="tabIndexStyle slider round" ></span>
                           <span className="onOff"></span>
                        </label>
                     </div>, document.getElementById('onScreenControlContainer'))}
               </div>
               <button className='expandColapsBtn' onClick={menuExpandCollaps}></button>
            </div>
            <FooterControl data={uiDataList.ui} onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandleMenu} />
         </div>
      </>
   );
}

export default Menu;